<template>
    <div>
        <div class="father">
            <div v-for="timeItem,index in timeList" :key="index">
                <PopTable
                :timeItem="timeItem"
                :allTimearr="allTimearr"
                :isAllbtn="isAllbtn"
                @passThrough='passThrough'
                @sendBack='sendBack'
                ></PopTable>
            </div>
        </div>                                                
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import PopTable from './quotaChange-approval-pop-table.vue'
    export default {
      name: 'quotaChange-approval-pop-form',
      props: {
        popDataitem:{type:[], default:()=>[]},
        isAllbtn:{type:Boolean,default:true},
      },
      components: {
        PopTable
      },
      data () {
        return {
            isBtn: true,
            popData:[],
            showQuotapopbtn: true,
            timeList:[],
            allTimearr:[]
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        // console.log(this.popDataitem,'配额修改/确认 详情---孙组件--popDataitem');
        this.popData = this.popDataitem.data
        this.timeListhandle(this.popData)
        // console.log(this.popData,'配额修改/确认 详情---孙组件-popData');
        // this.init()
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            this.showQuotabtn()
        },
        timeListhandle (val) {
            let dataList = val
            let subArr = []
            for (let i = 0; i < dataList.length; i++) {
                for (let j = 0; j < dataList[i].subAssignList.length; j++) {
                    subArr.push(
                        {
                            'subAssignObj':dataList[i].subAssignList[j],
                            'themeDetail' :dataList[i].themeDetail
                        }
                    )   
                }
            }
            // console.log(subArr,'subArr');
            let subArr0 = []
            let subArr1 = []
            for (let item of subArr) {
              if (item.themeDetail.needTransitions == 0) {
                // 不转场
                subArr0.push(item)
              } else if (item.themeDetail.needTransitions == 1)  {
               // 转场
               subArr1.push(item)
              } else {
                return
              }  
            }
            let arrArr = []
            // 不转场
            let object = {} 
            subArr0.forEach((item) => {  
            let { assignStartTime,assignEndTime } = item.subAssignObj           
            if (!object[0]) {           
                object[0] = {          
                    assignStartTime,
                    assignEndTime,
                    children: []           
                }
            }
            object[0].children.push(item)        
            })
            if (Object.values(object).length > 0) {
              arrArr.push(Object.values(object)[0])
            }
            // 转场
            let object1 = {} 
            subArr1.forEach((item) => {  
            let { assignStartTime,assignEndTime } = item.subAssignObj           
            if (!object1[0]) {           
                object1[0] = {          
                    assignStartTime,
                    assignEndTime,
                    children: []           
                }
            }
            object1[0].children.push(item)        
            })
            if (Object.values(object1).length > 0) {
              arrArr.push(Object.values(object1)[0])
            }
            // 全部
            let object2 = {} 
            subArr.forEach((item) => {  
            let { assignStartTime,assignEndTime } = item.subAssignObj           
            if (!object2[0]) {           
                object2[0] = {          
                    assignStartTime,
                    assignEndTime,
                    children: []           
                }
            }
            object2[0].children.push(item)        
            })
            this.allTimearr = Object.values(object2)[0]
            this.timeList = arrArr
        },
        // 驳回
        sendBack (item) {
            this.$emit('sendBack',item)
        },
        // 同意
        passThrough (item) {
            this.$emit('passThrough',item)
        },
        showQuotabtn () {
            if (this.popData.length == 2) {
                if ((this.popData[0].subAssignList[0].buChangeQty == this.popData[0].subAssignList[0].assignQty &&
                    this.popData[1].subAssignList[0].buChangeQty == this.popData[1].subAssignList[0].assignQty) ||
                    (this.popData[0].subAssignList[0].buChangeQty == null ||
                    this.popData[1].subAssignList[0].buChangeQty == null) ) {
                    this.showQuotapopbtn = false
                }
                
            } else if (this.popData.length == 3) {
                // ||
                //     (this.popData[0].subAssignList[0].buChangeQty == null &&
                //     this.popData[1].subAssignList[0].buChangeQty == null &&
                //     this.popData[2].subAssignList[0].buChangeQty == null) ) 
                if (this.popData[0].subAssignList[0].buChangeQty == this.popData[0].subAssignList[0].assignQty &&
                    this.popData[1].subAssignList[0].buChangeQty == this.popData[1].subAssignList[0].assignQty &&
                    this.popData[2].subAssignList[0].buChangeQty == this.popData[2].subAssignList[0].assignQty){
                    this.showQuotapopbtn = false
                }  
            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
